import axiosInstance from "src/utils/axios";

import { endpoints } from "src/utils";
import { createResourceActions } from "src/actions/utils/create-action";

const customActions = {
    runNow: async (scheduleId) => {
        const endpoint = endpoints.me.inStoreReportsSchedules.runNow(scheduleId);

        const url = endpoint;

        const response = await axiosInstance.post(url);

        if (response.status === 400) {
            throw new Error('Failed to execute report schedule');
        }

        return response.data;
    },
};


/*
// Create standardized actions for InStore Report Schedules
*/
export const meInStoreReportScheduleActions = createResourceActions(endpoints.me.inStoreReportsSchedules.list, {
    idField: 'scheduleId',
    customActions
});

const {
    create: createMeInStoreReportSchedule,
    delete: deleteMeInStoreReportSchedule,
    get: useGetMeInStoreReportSchedule,
    list: useGetMeInStoreReportSchedules,
    update: updateMeInStoreReportSchedule,
    upsert: upsertMeInStoreReportSchedule,
    partialUpdate: partialUpdateMeInStoreReportSchedule,
} = meInStoreReportScheduleActions;

export {
    createMeInStoreReportSchedule,
    deleteMeInStoreReportSchedule,
    useGetMeInStoreReportSchedule,
    updateMeInStoreReportSchedule,
    upsertMeInStoreReportSchedule,
    useGetMeInStoreReportSchedules,
    partialUpdateMeInStoreReportSchedule,
};
